'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _defaultStyles = require('../default-styles');

var _defaultStyles2 = _interopRequireDefault(_defaultStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var overrideStyles = {
  body: {
    display: 'flex',
    lineHeight: '18px'
  },
  image: {
    borderRadius: '4px',
    width: 'auto',
    height: 'auto',
    maxWidth: '100%',
    maxHeight: '200px',
    objectFit: 'cover'
  },
  compact: {
    display: 'initial'
  }
};

exports.default = (0, _merge2.default)({}, _defaultStyles2.default, overrideStyles);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/message/image-message/styles.js
// module id = 301
// module chunks = 0